interface CardTypeType {
  type: string,
  name: string,
  length: number[],
  prefixes: string[],
  spacing: number[],
  icon: 'Visa' | 'Amex' | 'MasterCard' | 'Discover',
  iconColor?: string,
  cscPaymentsType: string,
}

const cardFormats: CardTypeType[] = [
  {
    type: 'visa',
    name: 'Visa',
    length: [13, 19],
    prefixes: ['4'],
    spacing: [4, 4, 4, 4, 4],
    icon: 'Visa',
    iconColor: '#222357',
    cscPaymentsType: 'visa',
  },
  {
    type: 'amex',
    name: 'American Express',
    length: [15],
    prefixes: ['34', '37'],
    spacing: [4, 6, 5],
    icon: 'Amex',
    iconColor: '#006FCF',
    cscPaymentsType: 'american express',
  },
  {
    type: 'mastercard',
    name: 'MasterCard',
    length: [16],
    prefixes: ['51-55', '222100-272099'],
    spacing: [4, 4, 4, 4],
    icon: 'MasterCard',
    iconColor: '#FF5F00',
    cscPaymentsType: 'mastercard',
  },
  {
    type: 'discover',
    name: 'Discover',
    length: [16],
    prefixes: ['6011', '622126-622925', '644-649', '65'],
    spacing: [4, 4, 4, 4],
    icon: 'Discover',
    iconColor: '#F69E35',
    cscPaymentsType: 'discover',
  },
  {
    type: 'dinersClub',
    name: 'Diners Club',
    length: [14],
    prefixes: ['300-305', '309', '36', '38-39'],
    spacing: [4, 6, 6],
    cscPaymentsType: 'discover',
    icon: 'Discover',
  },
  {
    type: 'default',
    name: 'Unknown',
    length: [13, 20],
    prefixes: [],
    spacing: [4, 4, 4, 4, 4],
    cscPaymentsType: 'discover',
    icon: 'Discover',
  },
]

function removeSpacesFromCCNumber(number: number | string): string {
  return `${number}`.replace(/[^\d ]+/g, '').replace(/ +/g, '').replace(/ /g, '')
}

export const cardNumberToCardType = (number: string): CardTypeType => {
  const valueWithoutSpaces = removeSpacesFromCCNumber(number)
  return (
    cardFormats.find((format) => format.prefixes.some((prefix) => {
      if (prefix.includes('-')) {
        const [lower, upper] = prefix.split('-')
        const portion = parseInt(valueWithoutSpaces.slice(0, lower.length), 10)
        return parseInt(lower, 10) <= portion && parseInt(upper, 10) >= portion
      }
      return parseInt(prefix, 10) === parseInt(valueWithoutSpaces.slice(0, prefix.length), 10)
    }))
    || cardFormats[cardFormats.length - 1]
  )
}

export const cardTypeToCardIconId = (type: string) => {
  const card = cardFormats.find(({ cscPaymentsType }) => cscPaymentsType === type) || cardFormats[cardFormats.length - 1]
  return card.icon
}
